import { useEffect } from "react";

import useRequest from "./useRequest";
import { QUINE_APP_VERSION } from "../../constants/common";
import pageHardReload from "../../utils/pageHardReload";
import { useToast } from "../../components/Toast";

export const useVersionCheck = () => {
  const { data } = useRequest<{ version: string }>(
    {
      url: "/api/version",
    },
    {
      dedupingInterval: 60000, // check once per 1 min
    },
    false,
    null,
    false
  );

  const latestVersion = data?.version;

  const { toast } = useToast();

  useEffect(() => {
    if (!latestVersion || latestVersion === QUINE_APP_VERSION) {
      return;
    }
    toast("There is a new app version. Refresh to update!", {
      autoClose: false,
      positiveCtaText: "Refresh",
      onPositiveCta: () => pageHardReload(window.location.href),
      toastId: "outdatedQuineAppVersion",
    });
  }, [latestVersion, toast]);
};
